module.exports = __webpack_public_path__ + "static/author-dots-opt-23c6274ba54ce0d11e296688ac0c0482.png";